// extracted by mini-css-extract-plugin
module.exports = {"container":"SwipeActionButton_container__1Ymun","skip":"SwipeActionButton_skip__3pUsx","like":"SwipeActionButton_like__15TOc","label":"SwipeActionButton_label__3uxXS"};